import React from 'react';
import { Link } from "react-router-dom";
import './../../styles/home/principal.css'; // Estilos CSS para el componente

const Principal = () => {

  const homeImage = "https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Home%2Fhome-banner-recortada.jpg?alt=media&token=f4cb2fa6-5301-4a0e-861c-e2801c22b277";

  return (
    <div className="principal-component">
       <div className="background-image" style={{backgroundImage: `url(${homeImage})`}}>
        <div className="text-overlay">
          <h1>NOI</h1>
          <p>ESTÉTICA PROFESIONAL A DOMICILIO EN DONOSTIA</p>
              <Link to='/services' className="button home">
                Servicios
              </Link>  
              <Link to='/booking' className="button home">
                 Pedir cita
              </Link>
        </div>
      </div>
    </div>
  );
};

export default Principal;
